import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { WalletCurrencyType } from 'api/Trading-Accounts/Types/WalletCurrencyType'
import { multiSelectFilterCell } from 'components/Filter/FilterCell'
import { SelectValue } from 'components/Filter/FilterCell/MultiSelectFilterCell'
import { useAppSelector } from 'store'

export enum PaymentProvidersFilterKey {
  PspGroupType = 'PspGroupTypeId',
}

export const TickmillCompanyFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return multiSelectFilterCell({
    items: tickmillCompanies.map((x) => ({ id: x.id, value: x.name, label: x.name })),
  })(props)
}

const companiesOperator = (
  value: { company: { name: string } }[],
  selectedValues: SelectValue[]
) => {
  if (selectedValues.length === 0) {
    return true
  }

  return selectedValues.find((selectedName) => {
    return !!value.find((x) => x.company.name === selectedName)
  })
}

export const CompaniesFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return multiSelectFilterCell({
    items: tickmillCompanies.map((x) => ({ id: x.id, value: x.name, label: x.name })),
    options: {
      operator: companiesOperator,
    },
  })(props)
}

export const CurrenciesFilterCell = multiSelectFilterCell({
  items: Object.keys(WalletCurrencyType).map((x) => ({ id: x, value: x, label: x })),
})
